import styled from 'styled-components'
import { fieldLabel } from '../../styles/common'

const History = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 4px;

  ${fieldLabel}

  button {
    min-width: 124px;
  }
`

export default {
  History,
}
